import { createFeatureSelector } from '@ngrx/store';
import { AssignCheckbookReducer, AssignCheckbookState } from './assign-checkbook.reducer';
import { CheckbookDetailsReducer, CheckbookDetailsState } from './checkbook-details.reducer';
import { GenerateCheckbookReducer, GenerateCheckbookState } from './generate-checkbook.reducer';
import { SearchCheckbooksReducer, SearchCheckbooksState } from './search-checkbooks.reducer';
import { SearchGroupTemplatesReducer, SearchGroupTemplatesState } from './search-group-templates.reducer';
import { SideNavReducer, SidenavState } from './sidenav.reducer';
import { CheckbookGroupTemplateReducer, CheckbookGroupTemplateState } from './checkbook-group-template.reducer';

export const featureCheckbooksName = 'Checkbooks';
export interface DragonflyState {
  searchCheckbooks: SearchCheckbooksState;
  generateCheckbook: GenerateCheckbookState;
  searchGroupTemplates: SearchGroupTemplatesState;
  sidenav: SidenavState;
  checkbookDetails: CheckbookDetailsState;
  assignCheckbook: AssignCheckbookState;
  checkbookGroupTemplate: CheckbookGroupTemplateState;
}

export const moduleCheckbooksReducers = {
  searchCheckbooks: SearchCheckbooksReducer,
  generateCheckbook: GenerateCheckbookReducer,
  searchGroupTemplates: SearchGroupTemplatesReducer,
  sidenav: SideNavReducer,
  checkbookDetails: CheckbookDetailsReducer,
  assignCheckbook: AssignCheckbookReducer,
  checkbookGroupTemplate: CheckbookGroupTemplateReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(featureCheckbooksName);
